module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"indicator-general-follow-up-note":"Note de suivi"},"en":{"indicator-general-follow-up-note":"Follow-up note"}}')
  delete Component.options._Ctor
}
